import '../../sass/pages/_register.scss'

// IMPORT SERVICES
import { sendDataLayer } from "../services/datalayers";

// IMPORT COMPONENTS
import InputFiles from "../components/inputFiles";
import Modal from "../components/modal";

// IMPORT LIBRARIES
import * as Bouncer from "formbouncerjs";
import Swiper, { Scrollbar } from "swiper";
import "swiper/css";
import "swiper/css/scrollbar";

import { emails } from "../utils/constants";

declare var gsap: any;
declare var ScrollTrigger: any;
gsap.registerPlugin(ScrollTrigger);

// Initialize
init();

function init() {
    gsap.set('.trnz-register__title, .trnz-register__subtitle, .trnz-register__desc, .trnz-register__form', {
        opacity: 0, translateY: 30
    })
    gsap.set('.form__box', {
        opacity: 0, translateX: 30
    })

    document.querySelector('#business-logo')?.addEventListener('change', (e: Event) => {
        let target = e.target as HTMLInputElement;
        if (target.files.length > 0) {
            var src = URL.createObjectURL(target.files[0]);
            var preview = document.querySelector("#business-logo-image") as HTMLImageElement;
            preview.src = src;
        }
    })

    let maxFiles = document.querySelector('.trnz-counter-images__max')

    new InputFiles('#product-image', {
        wrapperImages: '#productSwiper .swiper-wrapper',
        dropZone: '#drop_zone',
        maxFiles: parseInt(maxFiles.innerHTML) || 0,
        on: {
            changeFiles: () => {
                let productSwiper = document.querySelector('#productSwiper') as any
                productSwiper.swiper.update()

                if (productSwiper.swiper.slides.length == 0) productSwiper.classList.remove('trnz-swiper-active')
                else productSwiper.classList.add('trnz-swiper-active')

            },
            createImage: (wrapperImage: HTMLElement, id: string) => {
                return `
                    <div id="${id}" class="swiper-slide">
                        ${wrapperImage.outerHTML}
                    </div>
                `
            }
        },
    })

    setValidations()
    createSwiper()

    new Modal('#popupAlert', { mainClass: 'trnz-popup' })
}

function createSwiper() {
    new Swiper('#productSwiper', {
        modules: [Scrollbar],
        spaceBetween: 20,
        slidesPerView: 'auto',
        grabCursor: true,
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
            snapOnRelease: true
        },
    })
}

function setValidations() {
    const registerForm = Bouncer('#adduserform', {
        disableSubmit: true,
        patterns: {
            email: /^[a-zA-Z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/
        },
        customValidations: {
            emailVerified: function (field: any) {
                if (field.type === 'email') {
                    let array_email = field.value.split("@");
                    const res = emails.find(m => m === array_email[1]);
                    return res === undefined ? false : true;
                }
            },
        },
        messages: {
            patternMismatch: {
                email: 'Por favor ingrese un email válido',
            },
            missingValue: {
                checkbox: (e: any) => {
                    if (e.name == 'terms') return 'Debe aceptar Términos y condiciones y Políticas de privacidad'
                    return 'Debe autorizar el tratamiento de datos personales'
                },
                default: (e: any) => {
                    if (e.tagName === 'SELECT') return 'Selecciona una opción'

                    let label = e.previousElementSibling?.innerHTML || ''
                    switch (e.name) {
                        case 'name_entrepre':
                            return `Debes ingresar el nombre de tu local`

                        case 'phone':
                            return `Debes ingresar tu número de Whatsapp`

                        case 'description':
                            return `Debes ingresar la descripción de tu negocio`

                        default:
                            return `Debes ingresar tu ${label.replace('*', '').toLowerCase()}`
                    }

                }
            },
            wrongLength: {
                over: 'Por favor, reduzca este texto a un máximo de {maxLength} caracteres. Actualmente está utilizando {length} caracteres.',
                under: 'Por favor, alargue este texto a {minLength} caracteres. Actualmente está utilizando {length} caracteres.'
            },
            emailVerified: 'Por favor ingrese un email válido',
        },
    })

    let submitBtn = document.querySelector('#edit-submit') as HTMLButtonElement

    if (submitBtn) {
        submitBtn.type = 'button';
        submitBtn.addEventListener('click', (e) => {
            document.querySelector('.trnz-overlay')?.classList.add('trnz-overlay--visible')

            let form = document.querySelector('#adduserform') as HTMLFormElement;
            registerForm.validateAll(form)

            let formData: any = new FormData(form);
            let productFiles: any = document.querySelector('#product-image')

            for (var i = 0; i < productFiles.files.length; i++) {
                formData.append("img_product[]", productFiles.files[i]);
            }

            fetch('/aguila-braids/entrepren', {
                method: 'POST',
                body: formData
            })
                .then((response: any) => response.json())
                .then((data: any) => {
                    document.querySelector('.trnz-overlay')?.classList.remove('trnz-overlay--visible')
                    console.log(data.status);
                    switch (data.status) {
                        case 'RECORD_EXISTING':
                            document.querySelector('#popupAlert')?.classList.remove('trnz-popup--hide')
                            let recordMessage = document.querySelector('#alertMessage')
                            if (recordMessage){
                                recordMessage.innerHTML = '';
                                data.erros.forEach((element:any) => {
                                    recordMessage.innerHTML += element+'<br>';
                               });
                            }
                            window.scrollTo(0, 240);
                            break;

                        case 'NOT_TIME':
                            document.querySelector('#popupAlert')?.classList.remove('trnz-popup--hide')
                            let noTimeMessage = document.querySelector('#alertMessage')
                            if (noTimeMessage) noTimeMessage.innerHTML = 'El registro actualmente no se encuentra habilitado<br>'
                            break;

                        case 'NOT_DATA':
                            let errors = document.querySelectorAll('.error-message') as any;
                            errors.forEach((element:any) => {
                                if(element.innerHTML != 'Debe aceptar Términos y condiciones y Políticas de privacidad'){
                                    window.scrollTo(0, 240);
                                }
                            });


                            sendDataLayer({
                                'event': 'GAEvent',
                                'event_category': 'Content',
                                'event_action': 'Submit',
                                'event_label': `Email`,
                            })
                            break;

                        case 'SUCCESS':
                            sendDataLayer({
                                'event': 'GAEvent',
                                'event_category': 'Content',
                                'event_action': 'Success',
                                'event_label': `Email`,
                            })
                            location.href = form.dataset.redirect
                            break;

                        default:
                            break;
                    }
                    sendDataLayer({
                        'event': 'GAEvent',
                        'event_category': 'Register',
                        'event_action': 'Submit',
                        'event_label': `Form`,
                    })

                })
                .catch((error: any) => {
                    console.log(error);
                })
        })
    }
}

window.addEventListener('load', () => {
    gsap.to('.trnz-register__title, .trnz-register__subtitle, .trnz-register__desc, .trnz-register__form', {
        duration: .8, opacity: 1, translateY: 0, stagger: 0.2
    })
        .then(() => {
            ScrollTrigger.batch('.form__box', {
                onEnter: (batch: any) => gsap.to(batch, { duration: 0.8, opacity: 1, translateX: 0, stagger: 0.2 })
            })
        })
})

document.addEventListener('lazybeforeunveil', function (e: any) {
    var bgClass = e.target.getAttribute('data-bg-class');
    if (bgClass) e.target.classList.add(bgClass)
});

const mObserver = new MutationObserver((mutations, observer) => {
    mutations.forEach(mutation => {
        if (mutation.type == 'childList') {
            let target = mutation.target as HTMLElement
            if (target.classList.contains('js-form-item')) {
                if (target.querySelector('.error-message')) {
                    target.classList.add('js-form-item--error')
                }
                else {
                    target.classList.remove('js-form-item--error')
                }
            }
            else if (target.classList.contains('form-textarea-wrapper')) {
                let parent = target.closest('.js-form-item')
                if (parent && target.querySelector('.error-message')) {
                    parent.classList.add('js-form-item--error')
                }
                else if (parent) {
                    parent.classList.remove('js-form-item--error')
                }
            }
        }

    })
})

mObserver.observe(document.querySelector('#adduserform'), { childList: true, attributes: true, subtree: true })
